import { isDebug } from './utils/misc'

export function log(...args: unknown[]): void {
  if (window.DEBUG) {
    console.log(...args)
  }
}

export function error(...args: unknown[]): void {
  console.error(...args)
}

export function debug(section: string, ...args: unknown[]): void {
  if (isDebug(section)) {
    console.log(...args)
  }
}
